import React, {  } from 'react';
import { useHistory } from 'react-router-dom'
import { makeStyles, Grid, Typography, IconButton,  } from '@material-ui/core';
import { CircleArrowFowardIcon } from '../icons'
//import { CheckButton } from './'
//import { theme } from '../theme' 

export default function LabCard(props) {

  const { lab, viewList } = props
  const classes = useStyles({lab, viewList, ...props})()
  const history = useHistory()

  const labDetails = () => {
    history.push({ pathname:"laboratory", state:{ lab }})  
  }

  return (
    <Grid container>
      <Grid container alignItems="center" className={classes.box}>
        <div><Typography>{lab.name.charAt(0)}</Typography></div>
        <div>
            <Typography>Laboratorio</Typography>
            <Typography>{lab.name}</Typography>
        </div>
        <div>
          <IconButton onClick={labDetails}><CircleArrowFowardIcon /></IconButton>
        </div>
      </Grid>
    </Grid>
  );
}


const useStyles = ({lab, viewList, ...props}) => makeStyles((theme) => ({
  box:{
    background: "#FFFFFF",
    boxShadow: "0px 4px 10px rgba(198, 198, 198, 0.5)",
    borderRadius: 22,
    width: "100%",
    height:viewList ? 85 : 150,
    padding:13,
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    '& div:nth-child(1)':{
        width:viewList ? "16%" : 50,
        height:50,
        borderRadius:15,
        display:"flex", 
        justifyContent:"center", 
        alignItems:"center",
        backgroundColor:lab.color,
        '& p':{
            fontSize:"2rem",
            color:"#FFF",
            fontWeight:"bold",
        }
    },
    '& div:nth-child(2)':{
      width:viewList ? "74%":"90%",
      padding:viewList ? "5.5px 0 10px 15px" :0,
      height:50,
      boxSizing:"border-box",
      '& p:nth-child(1)':{
        fontSize:"0.813rem",
        lineHeight:"1rem",
        color:theme.palette.secondary.main,
        fontWeight:"bold",
      },
      '& p:nth-child(2)':{
        margin:"2px 0 0 0",
        fontSize:"0.875rem",
        lineHeight:"1.063rem",
        color:theme.palette.primary.main,
        fontWeight:"500",
      },
      '& div':{
        height:"fit-content",
        
      },
      '& img':{
        objectFit:"contain"
      }
    },
    '& div:nth-child(3)':{
      width:"10%",
      height:viewList ? "100%":50, 
      display:"flex", 
      justifyContent:"center", 
      alignItems:viewList ? "center":"start",
      '& img':{
        objectFit:"contain"
      },
      '& button':{
        padding:viewList ? "initial":0
      }
    },
  },
}));